import type { RouteObject } from "react-router-dom";

/*
  The routes of the engineer's session (BUILD-PLAN 2.11.2): the session and its parts, the live map of an item, and the
  restore control. The pages load when they are first opened, so the map library is not part of the first download.
  The block renderers `plan`, `cards` and `hand_over` are registered by the session page when it loads (see `blocks.ts`).
  Who may open each address is in `app/screens.ts`; it is not repeated here.
*/

export const routes: RouteObject[] = [
  { path: "/sessions/new", lazy: async () => ({ Component: (await import("./pages/NewSessionPage")).NewSessionPage }) },
  { path: "/sessions/:id", lazy: async () => ({ Component: (await import("./pages/SessionPage")).SessionPage }) },
  { path: "/sessions/:id/log", lazy: async () => ({ Component: (await import("./pages/SessionLogPage")).SessionLogPage }) },
  { path: "/sessions/:id/checks", lazy: async () => ({ Component: (await import("./pages/ChecksPage")).ChecksPage }) },
  { path: "/sessions/:id/coverage/:reportId", lazy: async () => ({ Component: (await import("./pages/CoveragePage")).CoveragePage }) },
  { path: "/sessions/:id/hand-overs/:hoId", lazy: async () => ({ Component: (await import("./pages/HandOverPage")).HandOverPage }) },
  { path: "/items/:id/map", lazy: async () => ({ Component: (await import("./pages/ItemMapPage")).ItemMapPage }) },
  { path: "/restore", lazy: async () => ({ Component: (await import("./pages/RestorePage")).RestorePage }) },
];
